import { Type, AlignLeft, Calendar, ChevronDown, CheckSquare, Hash, ToggleLeft, ListChecks, PoundSterling } from 'lucide-react';

export const FIELD_TYPES = {
  TEXT: {
    value: 'TEXT',
    label: 'Text Input',
    icon: Type,
    description: 'Single line text input',
    hasPlaceholder: true,
    validationOptions: ['min_length', 'max_length', 'pattern']
  },
  TEXTAREA: {
    value: 'TEXTAREA',
    label: 'Text Area',
    icon: AlignLeft,
    description: 'Multi-line text input',
    hasPlaceholder: true,
    validationOptions: ['min_length', 'max_length', 'max_rows']
  },
  DATE: {
    value: 'DATE',
    label: 'Date Picker',
    icon: Calendar,
    description: 'Date selection',
    hasPlaceholder: false,
    validationOptions: ['min_date', 'max_date', 'allow_past', 'allow_future']
  },
  NUMBER: {
    value: 'NUMBER',
    label: 'Number Input',
    icon: Hash,
    description: 'Numeric input',
    hasPlaceholder: true,
    validationOptions: ['min_value', 'max_value', 'allow_decimals']
  },
  BOOLEAN: {
    value: 'BOOLEAN',
    label: 'Boolean',
    icon: ToggleLeft,
    description: 'True/False toggle switch',
    hasPlaceholder: false,
    validationOptions: ['default_value']
  },
  DROPDOWN: {
    value: 'DROPDOWN',
    label: 'Dropdown',
    icon: ChevronDown,
    description: 'Single selection from predefined options',
    hasPlaceholder: true,
    validationOptions: ['options']
  },
  MULTI_SELECT: {
    value: 'MULTI_SELECT',
    label: 'Multi-Select',
    icon: ListChecks,
    description: 'Multiple selections from predefined options',
    hasPlaceholder: true,
    validationOptions: ['options', 'min_selections', 'max_selections']
  },
  CURRENCY: {
    value: 'CURRENCY',
    label: 'Currency (£)',
    icon: PoundSterling,
    description: 'Currency input in pounds sterling',
    hasPlaceholder: true,
    validationOptions: ['min_value', 'max_value']
  }
};

// Array of field types for easy iteration
export const FIELD_TYPE_OPTIONS = Object.values(FIELD_TYPES);

// Default validation rules for each type
export const DEFAULT_VALIDATION_RULES = {
  TEXT: {
    min_length: null,
    max_length: 255,
    pattern: null
  },
  TEXTAREA: {
    min_length: null,
    max_length: 5000,
    max_rows: 10
  },
  DATE: {
    min_date: null,
    max_date: null,
    allow_past: true,
    allow_future: true
  },
  NUMBER: {
    min_value: null,
    max_value: null,
    allow_decimals: false
  },
  BOOLEAN: {
    default_value: false
  },
  DROPDOWN: {
    options: []
  },
  MULTI_SELECT: {
    options: [],
    min_selections: null,
    max_selections: null
  },
  CURRENCY: {
    min_value: null,
    max_value: null
  }
};
